// import required libraries
import $ from "jquery";

// import components that run on every page
import Header from "./components/Header";

// Import Pages
import PageContact from "./pages/PageContact";
import accessibility from "./actions/accessibility";
import PageFrontPage from "./pages/PageFrontPage";
import PageNews from "./pages/PageNews";
import Page404 from "./pages/Page404";
import PageEventsIndex from "./pages/PageEventsIndex";
import PageTickets from "./pages/PageTickets";
import PagePerformanceIndex from "./pages/PagePerformanceIndex";
import PageRidesAndGamesIndex from "./pages/PageRidesAndGamesIndex";
import PageShoppingIndex from "./pages/PageShoppingIndex";
import PageCareers from "./pages/PageCareers";
import PageSchedule from "./pages/PageSchedule";
import PageDefault from "./pages/PageDefault";
import PageEventSingle from "./pages/PageEventSingle";
import PageMap from "./pages/PageMap";
import PageFoodIndex from "./pages/PageFoodIndex";
import RaffleJackpot from "./components/RaffleJackpot"
import PageHrLanding from "./pages/PageHrLanding";
import PageSchoolTickets from "./pages/PageSchoolTickets";

// call functions
accessibility();
PageContact($);
PageFrontPage($);
PageNews($);
PageEventsIndex($);
PageTickets($);
Header($);
Page404($);
PageDefault($);
PageEventSingle($);
PageMap($);
RaffleJackpot($);
PageHrLanding($);

//react pages
PagePerformanceIndex($);
PageRidesAndGamesIndex($);
PageShoppingIndex($);
PageSchedule($);
PageFoodIndex($);
PageSchoolTickets($);
PageCareers($);
